import { createSelector } from '@reduxjs/toolkit';
import { takesFlagsDataSelector } from './takesFlags';
import { flagsDataSelector } from './flags';
import { find } from 'lodash';
import { reduxTakeValidationMediasDataSelector } from './reduxTakeValidationMedias';
import { reduxMediasDataSelector } from './reduxMedias';
import { reduxTakeRefMediasDataSelector } from './reduxTakeRefMedias';
import { reduxFlagsDataSelector } from './reduxFlags';
export const takesReducer = (state) => state.reduxTakes;
export const takesDataSelector = createSelector(takesReducer, (selector) => selector.data);
const statusDataSelector = (state) => state.progressionStatus.resources;
export const takesDataWithRelationsSelector = createSelector([
    takesDataSelector,
    statusDataSelector,
    takesFlagsDataSelector,
    reduxFlagsDataSelector,
    flagsDataSelector,
    reduxTakeValidationMediasDataSelector,
    reduxMediasDataSelector,
    reduxTakeRefMediasDataSelector,
], (takes, status, takesFlags, reduxFlags, allFlags, validationMediasRelations, reduxMedias, refMediasRelations) => {
    const takesWithStatusAndFlags = takes.map((take) => {
        const statusInst = find(status, (s) => s.id === take.status);
        const relatedTakesFlags = takesFlags.filter((takeFlag) => takeFlag.take === take.id);
        const relatedFlags = relatedTakesFlags.map((takeFlag) => {
            var _a;
            const flagInst = (_a = [...reduxFlags, ...Object.values(allFlags)].find((flag) => flag.id === takeFlag.flag)) !== null && _a !== void 0 ? _a : take.flagsInst.find((flag) => flag.id === takeFlag.flag);
            return Object.assign(Object.assign({}, takeFlag), { flagInst });
        });
        const takeValidationMediasRelations = validationMediasRelations.filter((relation) => relation.take === take.id);
        const takeValidationMediasInst = takeValidationMediasRelations.map((el) => {
            const relatedMedia = [...reduxMedias].find((media) => media.id === el.media);
            return Object.assign(Object.assign({}, el), { mediaInst: relatedMedia });
        });
        const takeRefMediasRelations = refMediasRelations.filter((relation) => relation.take === take.id);
        const takeRefMediasInst = takeRefMediasRelations.map((el) => {
            const relatedMedia = [...reduxMedias].find((media) => media.id === el.media);
            return Object.assign(Object.assign({}, el), { mediaInst: relatedMedia });
        });
        return Object.assign(Object.assign({}, take), { statusInst, takeFlagsInst: relatedFlags, takeValidationMediasInst, takeRefMediasInst });
    });
    return takesWithStatusAndFlags;
});
